import styled from 'styled-components'

export const NavigationPanel = styled.nav`
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  gap: 1rem;
  flex-wrap: wrap;
`
